export default __webpack_public_path__ + "static/media/mastercard.f0811da6.png";